import React, { useRef, useState } from 'react';
import { Field, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import WithError from '../../../../components/with-error/WithError';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import CommonIconButton from '../../../../components/common-icon-button/CommonIconButton';
import TooltipButton from '../../../../components/tooltip-button/TooltipButton';

import scss from './UploadImageButton.module.scss';

function UploadImageButton() {
  const { t } = useTranslation('id8');

  const form = useForm();
  const hiddenFileInput = useRef(null);
  const [fileName, setFileName] = useState('');

  const handleOpenChooseFile = () => {
    hiddenFileInput.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      form.change('logo', file);
    }
  };

  const handleRemoveFile = () => {
    setFileName('');
    form.change('logo', null);
    hiddenFileInput.current.value = '';
  };

  return (
    <Field name='logo' type='file'>
      {({ meta, input }) => (
        <div className={scss.wrapper}>
          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
            <TooltipButton styleColor={BUTTON_STYLES.SECONDARY} onClick={handleOpenChooseFile} maxWidth={160}>
              <Icon icon={ICONS.ImportIcon} />
              {t('uploadImage')}
            </TooltipButton>

            <input
              type='file'
              name={input.name}
              onChange={handleFileChange}
              ref={hiddenFileInput}
              style={{ display: 'none' }}
            />
          </WithError>

          {fileName ? (
            <span className={scss.fileName}>
              {fileName}{' '}
              <CommonIconButton
                icon={ICONS.Cross}
                onClick={handleRemoveFile}
                isStrokeIcon
                iconClassName={scss.removeIcon}
              />
            </span>
          ) : null}
        </div>
      )}
    </Field>
  );
}

export default UploadImageButton;
